const SECONDS_PER_MINUTE = 60;
const SECONDS_PER_HOUR = 3600;

/** A video's length the way players print it: "0:47", "12:05", "1:02:09". */
export const formatMediaDuration = (totalSeconds: number): string => {
	const whole = Math.max(0, Math.round(totalSeconds));
	const hours = Math.floor(whole / SECONDS_PER_HOUR);
	const minutes = Math.floor((whole % SECONDS_PER_HOUR) / SECONDS_PER_MINUTE);
	const seconds = String(whole % SECONDS_PER_MINUTE).padStart(2, "0");
	return hours > 0 ? `${hours}:${String(minutes).padStart(2, "0")}:${seconds}` : `${minutes}:${seconds}`;
};
